import { Badge } from "@shopify/polaris"
import classNames from "classnames"
import React, { CSSProperties } from "react"

import styles from "./HotBadge.module.scss"
interface IProps {
  children?: string;
  className?: string[]
  style?: CSSProperties
}

export default function HotBadge (props: IProps) {
  return <div className={classNames(props.className)}>
    <Badge tone={"info"}>{props.children || "Hot"}</Badge>
  </div>
}
